export default __webpack_public_path__ + "static/media/goshen2.9d8f8c93.jpg";